import React, { Component, createRef } from 'react'
import PropTypes from 'prop-types'

import { uniqueIdentificationGenerator } from '../../utils/uniqueIdentificationGenerator'
import _ from 'lodash'

import warningIcon from 'images/warning-icon.svg'
import errorIcon from 'images/error-icon.svg'
import successIcon from 'images/success-icon.svg'
import ArrowDownGrey from 'component/svgComponents/arrowDownGrey'

class SelectField extends Component {
  static propTypes = {
    /* The input placeholder */
    placeholder: PropTypes.string,

    /* The text that will be displayed along with the input */
    label: PropTypes.string,

    /* The input name */
    name: PropTypes.string,

    /* The input id */
    id: PropTypes.string.isRequired,

    /* The text that will be displayed below the input */
    helpText: PropTypes.string,

    /* The text that will be displayed below the input when the input is valid */
    successText: PropTypes.string,

    /* The text that will be displayed below the input when an error is found */
    errorText: PropTypes.string,

    /* The text that will be displayed below the input when an warning need to be displayed */
    warningText: PropTypes.string,

    /* The element classes */
    className: PropTypes.string,

    /* The input container classes */
    containerClass: PropTypes.string,

    /* Initial value */
    value: PropTypes.any,
    initialValue: PropTypes.any,

    /* Callback for when the input changes */
    onChange: PropTypes.func,

    /* Determine if the input is or not required */
    required: PropTypes.bool,

    paramsSupply: PropTypes.bool,

    /* Determine if the input is or not disabled */
    disabled: PropTypes.bool,

    /* Determine if the input is or not readonly */
    readOnly: PropTypes.bool,

    /* Function that will be triggered when the value changes. May return true or false to wheter the new value is or not valid */
    validateValue: PropTypes.func,

    /* Determine if the select options are shown or not */
    isOpen: PropTypes.bool,

    /* Determine if the select is multiple */
    isMulti: PropTypes.bool,

    /* An array of options that will be loaded into the select */
    options: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.any.isRequired,
        divider: PropTypes.bool,
      })
    ),

    /* An Glyph class name to be shown on the right side of the input */
    rightIcon: PropTypes.string,

    /* An callback for when the glyph is clicked */
    onRightIconClick: PropTypes.func,

    /* An callback for when the select is clicked */
    onClick: PropTypes.func,

    /* An function to format the display value */
    formatLabel: PropTypes.func,

    /* An callback for when the dropdown is open */
    onDropdownOpen: PropTypes.func,

    /* A bool that controls the 100% width */
    fill: PropTypes.bool,

    /* translate function */
    translate: PropTypes.func,

    /* disable options search */
    disableSearch: PropTypes.bool,

    /* group selected options */
    groupOptions: PropTypes.bool,

    /* show select all option */
    selectAll: PropTypes.bool,

    allOptionsSelected: PropTypes.bool,

    allowCreateOnSearch: PropTypes.bool,

    // used to show or hide the area above input with helpers texts
    showHelperArea: PropTypes.bool,

    multiRemove: PropTypes.bool,

    /* dropdown placement: 'top' opens above the input, 'bottom' (default) opens below */
    menuPlacement: PropTypes.oneOf(['top', 'bottom']),
  }

  state = {
    /* The input value  */
    value: this.props.value || this.props.initialValue || '',

    /* Stores the information of wheter the input is or not valid  */
    isValid: null,

    /* Determine if the select options are shown or not */
    isOpen: false,

    /* Determine from where to pick the value */
    isControledInput: false,

    /* search options value */
    searchValue: '',

    allowCreateOnSearch: false,

    showHelperArea: this.props.showHelperArea || true,
  }

  ref = createRef()

  searchInput = createRef()

  dropdown = createRef()

  get value() {
    const { isControledInput } = this.state
    return isControledInput ? this.props.value : this.state.value
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClick)

    const { value } = this.props
    if (value) {
      this.setState({
        isControledInput: true,
        isValid: this.valueIsValid(value),
      })
    }

  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.value, this.props.value)) {
      this.checkProps()
    }
  }

  checkProps() {
    this.setState({
      value: this.props.value,
      isValid: this.valueIsValid(this.props.value),
    })
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick)
  }

  handleClick = (e) => {
    if (!this.ref.current.contains(e.target)) {
      this.setState({
        isOpen: false,
        searchValue: '',
      })
      this.searchInput.current.value = ''
    }
  }

  getClasses() {
    const { disabled, readOnly } = this.props
    const { isValid } = this.state
    const { value } = this
    return `
            ${disabled ? 'disabled' : ''}
            ${isValid === false ? 'invalid' : ''}
            ${isValid === true ? 'valid' : ''}
            ${readOnly ? 'read-only' : ''}
            ${
              (Array.isArray(value) && value.length > 0) ||
              (!Array.isArray(value) && value)
                ? 'filled'
                : ''
            }
        `
  }

  onChangeFilter = (filter) => this.setState({ filter })

  onChange = (value) => {

    const { onChange = () => {}, isMulti = false, multiRemove } = this.props
    const currentValue = this.value

    if (isMulti) {
      if (JSON.stringify(currentValue).indexOf(JSON.stringify(value)) > -1) {

        if(multiRemove) {
          value = currentValue.filter(
            (v) => JSON.stringify(v.value) !== JSON.stringify(value.value)

          )
        }
        else {
          value = currentValue.filter(
            (v) => JSON.stringify(v) !== JSON.stringify(value)

          )
        }

        // remotion

      } else {
        // add
        value = value ? [...currentValue, value] : currentValue
      }
    }

    setTimeout(() => {
      this.setState(
        {
          value,
          isValid: this.valueIsValid(value),
          isOpen: !!isMulti && !this.preventReopen,
        },
        () => {
          onChange && onChange(value)
          this.preventReopen = false
        }
      )
      if (!isMulti) {
        this.searchInput.current.value = ''
        this.setState({ searchValue: '' })
        this.searchInput.current.blur()
      }
    }, 100)
  }

  clearAll() {
    const { onChange = () => {} } = this.props
    const { isControledInput } = this.state
    if (!isControledInput) {
      this.setState({ value: [] }, () => {
        this.onChange([])
      })
    } else {
      onChange([])
    }
  }

  selectAll() {
    const { options, onChange = () => {} } = this.props
    const { isControledInput } = this.state

    if (!isControledInput) {
      this.setState({ value: options, isOpen: false }, () => {
        this.onChange(false)
      })
    } else {
      onChange(options)
      setTimeout(() => {
        this.setState({ isValid: this.valueIsValid(options), isOpen: false })
      }, 50)
    }
  }

  valueIsValid(value) {
    const { required, validateValue } = this.props

    if (validateValue) {
      return validateValue(value)
    }
    return required && value === ''
  }

  textHelperDisplay() {
    const { errorText, warningText, helpText, successText } = this.props
    const { isValid } = this.state

    if (errorText) {
      return ['error', <img key='errorIcon' src={errorIcon} />, errorText]
    }

    if (isValid === true) {
      if (successText)
        return ['success', <img key='successIcon' src={successIcon} />, successText]
    } else if (isValid !== false) {
      if (helpText) return ['default', null, helpText]
    } else {
      if (warningText) {
        return ['warning', <img key='warningIcon' src={warningIcon} />, warningText]
      }
    }

    return ['', null, null]

  }

  isOptionSelected = (opt) => {
    const { isMulti } = this.props
    const { value } = this

    if (isMulti) {
      return JSON.stringify(value).indexOf(JSON.stringify(opt)) > -1
    }
    return JSON.stringify(value) === JSON.stringify(opt)
  }

  formatLabel = (value) => (value || {}).label

  isEmpty() {
    const { isMulti } = this.props
    const { value } = this
    return !value || (isMulti && (value || []).length === 0)
  }

  onOpen() {
    const { onDropdownOpen = () => {} } = this.props
    this.setState({ isOpen: true }, (e) => {
      onDropdownOpen(e)
      window.addEventListener('resize', this.handleResize)
      document.addEventListener('scroll', this.handleScroll, true)
      this.forceUpdate()
    })
    this.searchInput.current.focus()
  }

  handleResize = () => {
    this.forceUpdate()
  }

  handleScroll = (e) => {
    if (!(this.ref.current || { contains: () => {} }).contains(e.target)) {
      this.setState({
        isOpen: false,
      })
    }
    this.forceUpdate()
  }

  getHtmlValues(element) {
    let currentElement = element
    let top = element.offsetTop
    const windowHeight = window.innerHeight

    while (currentElement.offsetParent) {
      currentElement = currentElement.offsetParent
      top += currentElement.offsetTop
    }

    currentElement = element
    let scrollTop = 0

    while (currentElement.parentElement) {
      if (window.getComputedStyle(currentElement).position === 'fixed') break
      scrollTop += currentElement.scrollTop
      currentElement = currentElement.parentElement
    }
    scrollTop += currentElement.scrollTop

    const calculatedTopValue = top - scrollTop + element.clientHeight
    const maxSelectedOpenHeight = windowHeight - calculatedTopValue - 10
    const finalMaxSelectedOpenHeight =
      maxSelectedOpenHeight < 200 && maxSelectedOpenHeight

    return [calculatedTopValue, finalMaxSelectedOpenHeight]
  }

  renderOptions() {
    const {
      options,
      placeholder,
      translate,
      isMulti,
      required,
      groupOptions,
      selectAll,
      allowCreateOnSearch,
    } = this.props
    const { searchValue } = this.state
    const { value } = this
    const { menuPlacement } = this.props
    let i = 0
    const startGrouping = isMulti && groupOptions && (value || []).length > 1
    const element = this.ref.current
    const [top, maxHeight] = this.getHtmlValues(element)

    let positionStyle
    if (menuPlacement === 'top') {
      const elRect = element.getBoundingClientRect()
      const modal = document.querySelector('.custom-modal')
      if (modal) {
        const modalRect = modal.getBoundingClientRect()
        const dropdownHeight = modalRect.height * 0.7
        positionStyle = {
          top: modalRect.top + (modalRect.height - dropdownHeight) / 2,
          maxHeight: dropdownHeight,
        }
      } else {
        positionStyle = {
          top: elRect.top,
          maxHeight: elRect.top - 10,
          transform: 'translateY(-100%)',
        }
      }
    } else {
      positionStyle = { top, ...(maxHeight && { maxHeight }) }
    }

    return (
      <ul
        ref={this.dropdown}
        className='input-container-select-dropdown'
        style={{
          width: element.offsetWidth,
          ...positionStyle,
        }}
      >
        {startGrouping && (
          <div className='selected-options'>
            {value.map((opt, a) => (
              <span className='input-container-select-multiple-option' key={a}>
                <span className='input-container-select-multiple-option-text'>{opt.label}</span>
                <span className='times'
                      onClick={(e) => {
                        e.stopPropagation()
                        this.preventReopen = true
                        this.onChange(opt)
                      }}
                      onMouseDown={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                      }}
                >
                  ×
                </span>
              </span>
            ))}
          </div>
        )}
        {placeholder && (!isMulti || (value || []).length < options.length) && (
          <li
            className='placeholder'
            onClick={() => {
              if (!isMulti && !required) this.onChange(false)
            }}
          >
            {placeholder}
          </li>
        )}
        {selectAll &&
          isMulti &&
          (value || []).length < options.length &&
          !searchValue && (
            <li onClick={() => this.selectAll()}>
              {translate ? translate('select.all') : 'Todos'}
            </li>
          )}
        {(options || []).map((opt, a) => {
          if (
            !searchValue ||
           opt.label && opt.label.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1
          ) {
            if (!this.isOptionSelected(opt) || !startGrouping) {
              i++
              return (
                <li
                  className={`${this.isOptionSelected(opt) ? 'active' : ''} ${
                    opt.divider ? 'divider' : ''
                  }`}
                  onClick={() => this.onChange(opt)}
                  key={a}
                >
                  {opt.label}
                </li>
              )
            }
          }
        })}
        {i === 0 && searchValue && !allowCreateOnSearch ? (
          <li className='no-results'>
            {translate
              ? translate('select.no-results')
              : `Nenhum resultado para'${searchValue}`}
          </li>
        ) : (
          allowCreateOnSearch &&
          searchValue.length > 1 &&
          options.filter(
            (e) => e.label.toLowerCase() === searchValue.toLowerCase()
          ).length <= 0 && (
            <li
              className='no-results'
              onClick={() =>
                this.onChange({
                  value: -999,
                  label: searchValue.toUpperCase(),
                })
              }
              key={-999}
            >
              {translate
                ? translate('mission-list.create-option')
                : 'Criar missão: '}{' '}
              {searchValue}
            </li>
          )
        )}
      </ul>
    )
  }

  renderSelectedOptions() {
    const { formatLabel, isMulti, groupOptions, options, translate, allOptionsSelected } =
      this.props
    const { value } = this

      if (isMulti) {
        if (groupOptions && (value || []).length > 1) {
          return (
            <span className='input-container-select-multiple-option'>
              <span className='input-container-select-multiple-option-text'>
                {allOptionsSelected || value.length === options.length
                  ? translate
                    ? translate('select.all')
                    : 'Todos'
                  : translate
                  ? translate('select.many')
                  : 'Vários'}
              </span>
              <span className='times'
                    onClick={(e) => {
                      e.stopPropagation()
                      this.preventReopen = true
                      this.clearAll()
                    }}
                    onMouseDown={(e) => {
                      e.stopPropagation()
                      e.preventDefault()
                    }}
              >
                ×
              </span>
            </span>
          )
        }
        return (value || []).map((opt, i) => (
          <span className='input-container-select-multiple-option' key={i}>
            <span className='input-container-select-multiple-option-text'>{opt.label}</span>
            <span className='times'
                  onClick={(e) => {
                    e.stopPropagation()
                    this.preventReopen = true
                    this.onChange(opt)
                  }}
                  onMouseDown={(e) => {
                    e.stopPropagation()
                    e.preventDefault()
                  }}
            >
              ×
            </span>
          </span>
        ))
      }
      return (
        <span className='input-container-select-multiple-placeholder filled'>
          {(formatLabel || this.formatLabel)(value)}
        </span>
      )
  }

  render() {
    const {
      label,
      rightIcon,
      onRightIconClick,
      required,
      disabled,
      className,
      id,
      placeholder,
      isMulti,
      fill,
      disableSearch,
      showHelperArea,
      containerClass,
      onClick,
      paramsSupply,
    } = this.props
    const { isOpen } = this.state
    const { value } = this

    const customId = id || uniqueIdentificationGenerator('input-text_')
    const classes = this.getClasses()
    const [inputValidationClass, inputSmallIcon, inputSmallText] =
      this.textHelperDisplay()

    return (
      <>
        <div
          onClick={onClick}
          ref={this.ref}
          className={`${
            containerClass || ''
          } input-container input-container-select ${
            disabled ? 'disabled' : ''
          } ${
            rightIcon ? 'right-icon' : ''
          } ${inputValidationClass} ${classes} ${
            disableSearch ? 'disable-search' : ''
          }`}
          style={fill ? { width: '100%', maxWidth: 'unset' } : {}}
        >
          <label>
            {label}
            {required !== true && <i> - opcional</i>}
          </label>
          <div
            id={customId}
            className={`as-input form-control ${isOpen ? 'open' : ''} ${
              className || ''
            }`}
            onClick={() => this.onOpen()}
            style={{
              border: value && (isMulti ? (value.length > 0) : value) ? '1px solid #add585' : '1px solid #ddd',
              borderRadius: '8px',
              transition: 'border-color 0.3s ease'
            }}
          >
            {(!value || (isMulti && (value || []).length === 0)) && (
              <span className='input-container-select-multiple-placeholder'>
                {placeholder}
              </span>
            )}
            {this.renderSelectedOptions()}
            <input
              type='text'
              className='search-input'
              ref={this.searchInput}
              onChange={(e) => this.setState({ searchValue: e.target.value })}
              readOnly={disabled || disableSearch}
            />
            {isOpen && this.renderOptions()}
          </div>
          <ArrowDownGrey onClick={() => this.setState({ isOpen: !isOpen })} className={paramsSupply ? 'arrow-params-supply' : 'arrow'} />

          {rightIcon && (
            <i
              className={`${
                value
                  ? `${rightIcon} right-icon`
                  : `${rightIcon} right-icon right-icon-inactive`
              }
                        `}
              onClick={() => {
                onRightIconClick && onRightIconClick()
                this.setState({ isOpen: false })
              }}
            />
          )}
          {inputSmallText && !showHelperArea && (
            <small className={inputValidationClass}>
              {inputSmallIcon}
              {inputSmallText}
            </small>
          )}
        </div>
      </>
    )
  }
}

export default SelectField
